import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import { ApiUrlGate } from './components/ApiUrlGate';
import { AppShell } from './components/AppShell';
import { SetupScreen } from './components/screens/SetupScreen';
import { PeopleScreen, MovesScreen, ReflectionsScreen, SettingsScreen } from './components/screens';
import { setupAPI } from './api/client';
import { initPostHog } from './lib/posthog';
import { ErrorBoundary } from './components/ErrorBoundary';

function SetupGuard() {
  const [checking, setChecking] = useState(true);
  const [setupComplete, setSetupComplete] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setupAPI.status()
      .then(s => {
        if (s.auth_token) {
          localStorage.setItem('clawer_auth_token', s.auth_token);
        }
        if (!s.setup_complete) {
          navigate('/setup', { replace: true });
        } else {
          setSetupComplete(true);
        }
      })
      .catch(() => {
        // fail-open: let the app load
      })
      .finally(() => setChecking(false));
  }, [navigate]);

  useEffect(() => {
    if (setupComplete) {
      initPostHog();
    }
  }, [setupComplete]);

  if (checking) {
    return (
      <div className="min-h-[100dvh] bg-canvas flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <span className="material-icons-round text-accent text-4xl animate-spin">sync</span>
          <p className="text-sm text-ink-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  return setupComplete ? <Outlet /> : null;
}

export default function App() {
  return (
    <ErrorBoundary>
    <ApiUrlGate>
      <BrowserRouter>
        <Routes>
          {/* Setup — always accessible, outside the guard */}
          <Route path="/setup" element={<SetupScreen />} />

          {/* Guarded layout routes */}
          <Route element={<SetupGuard />}>
            <Route element={<AppShell />}>
              <Route index element={<Navigate to="/people" replace />} />
              <Route path="/people" element={<PeopleScreen />} />
              <Route path="/moves" element={<MovesScreen />} />
              <Route path="/reflections" element={<ReflectionsScreen />} />
              <Route path="/health" element={<Navigate to="/settings" replace />} />
              <Route path="/usage" element={<Navigate to="/settings" replace />} />
              <Route path="/settings" element={<SettingsScreen />} />
              <Route path="*" element={<Navigate to="/people" replace />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </ApiUrlGate>
    </ErrorBoundary>
  );
}
